import { configureStore } from '@reduxjs/toolkit'
import counterReducer  from './components/user-view/counterSlice'
import navigatorReducer  from './components/user-view/navigatorSlice'
import changeReducer from './components/user-view/changeSlice'

// ...


export const store = configureStore({
  reducer: {
    counter: counterReducer,
    navigator: navigatorReducer,
    change: changeReducer
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState> // no tocar, te carga automaticamente los types de mis reducers importados
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch